import { withInstall } from '../utils/index';
import CitySelect from './index.vue';

export const TlbsCitySelect = withInstall(CitySelect);
export default TlbsCitySelect;
